
import { defineComponent, SetupContext } from "vue";
import NativeClient from "@/client/native-client";
export default defineComponent({
  name: "PantryDetailGuideDialog",
  components: {
  },
  props: {
  },
  setup(props, context: SetupContext) {
    const GUIDE_MESSAGE = "■入庫日とは</br>ユーザーが本アプリで食材を登録された日を入庫日として自動で設定します。</br></br>"
    + "■期限目安とは</br>入庫日と食材、保存場所に応じて消費期限の目安日が設定されます。</br>"
    + "これは、参考値であり、食材の品質を保証するものではありません。商品の賞味期限を確認し、設定してください。</br></br>"
    + "■おいしい保存のコツとは</br>食材のおいしさを少しでも長持ちさせるコツです。</br>お持ちの冷蔵庫での詳細な保存の仕方についてはお持ちの冷蔵庫の取扱説明書をご覧ください。</br>※保存期間を長くするコツではありません。<br>"
    const onClickClose = () => {
      context.emit("click-close");
    };
    return {
      onClickClose,
      GUIDE_MESSAGE
    };
  }
});
